export const GENDER = {
  NOT_SELECTED: null,
  MALE: 'male',
  FEMALE: 'female',
};

export const LABEL_BY_GENDER = {
  [GENDER.NOT_SELECTED]: 'Please select',
  [GENDER.MALE]: 'Male',
  [GENDER.FEMALE]: 'Female',
};

export const genderOptions = Object.values(GENDER).map((gender) => ({
  value: gender,
  label: LABEL_BY_GENDER[gender],
}));

export const USER_GOAL = {
  BUILD_MUSCLE: 'Build Muscle',
  LOSE_WEIGHT: 'Lose Weight',
  STAY_LEAN: 'Stay Lean or Maintain Weight',
  FUEL_SPORT: 'Fuel My Sport',
  EAT_HEALTHY: 'Eat Healthy',
};
